import { withForm } from 'components/Form';
import messages from './EmailModal.messages';
import EmailModal from './EmailModal';

const mapSubmitValues = values => ({
  ...values,
  message: values.message?.trim() ?? '',
});

const syncValidator = values => {
  const errors = {};
  const { message } = mapSubmitValues(values);

  if (!message) {
    errors.message = messages.messageRequired;
  }

  return errors;
};

export default withForm({
  name: 'EMAIL_MODAL_FORM',
  syncValidator,
  mapSubmitValues,
})(EmailModal);
